import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { useEffect, useRef } from 'react'
import { mapSelectValue } from '../../../utils'



const NmInformationForm = ({ navigation, route }) => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    essUserOnBoardingFormKey,
    essFormKey,
    mode,
    essUserOnBoardingKey
  } = params
  const { loading, postnmonline, getmodetails } = useFormsStore()
  const { initializeData } = useInitializeStore()
  const { personalData } = usePersonalStore()
  const intialValues = {
    maritalstatus: '',
    otherdependents: '',
    otherIncome: '',
    deductions: '',
    extraWithholdingPerPay: '',
    multiplejobs: '',
    ChildTaxCredit_Under17: "",
    OtherDependentCredit: "",
    claimExemption: ""
  }
  const w4schema = yup.object({
    maritalstatus: yup
      .mixed()
      .nullable()
      .required('Filing Status is a required field'),
    multiplejobs: yup
      .mixed()
      .nullable()
      .required('Multiple Jobs is a required field'),
    otherdependents: yup
      .number()
      .typeError('Please enter numeric values')
      .required('Dependents is a required field'),
    otherIncome: yup
      .number()
      .typeError('Please enter numeric values')
      .required('Other Income is a required field'),
    deductions: yup
      .number()
      .typeError('Please enter numeric values')
      .required('Deductions is a required field'),
    extraWithholdingPerPay: yup
      .number()
      .typeError('Please enter numeric values'),
    ChildTaxCredit_Under17:
      yup.number()
        .typeError('Please enter numeric values')
        .required("Child Tax Credit Under17 is a required field"),
    OtherDependentCredit: yup.number()
      .typeError('Please enter numeric values')
      .required("Other Dependents credit is a required field"),
    claimExemption: yup
      .mixed()
      .nullable()
      .required('Exempt from withholding is a required field'),
  })

  const options3 = [
    { key: 1, value: 'Single or Married filing separately ' },
    { key: 2, value: 'Married filing jointly or Qualifying surviving spouse' },
    { key: 3, value: 'Head of Household (Check only if you’re unmarried and pay more than half the costs of keeping up a home for yourself and a qualifying individual.)' }
  ]


  const options2 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }
  ]

  // useEffect(() => {
  //   getmodetails(initializeData?.userkey)
  // }, [])
  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel={'Forms'}
            navScreen="OnboardingForms"
            title={'NM Withholding Taxation'}
            essFormKey={essFormKey}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={w4schema}
          onSubmit={async (values, actions) => {
            const data = {
              essUserKey: initializeData.userkey,
              entityId: personalData.entityId,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: userId,
              maritalStatus: values?.maritalstatus,
              multipleJobs: values?.multiplejobs,
              otherDependents: values?.otherdependents,
              otherIncome: values?.otherIncome,
              deductions: values?.deductions,
              extraWithholding: values?.extraWithholdingPerPay?values?.extraWithholdingPerPay:null,
              completeOnline: mode === 'upload' ? false : true,
              childTaxCreditUnder17: values?.ChildTaxCredit_Under17,
              otherDependentCredit: values?.OtherDependentCredit,
              exemptWithholding: values?.claimExemption?.toString()
            }

            const w4Data: any = await postnmonline(data)

            if (w4Data?.success) {
              if (mode === 'upload') {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: w4Data?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              } else {
                navigation.navigate('NmInformationOnline', {
                  values,
                  essUserOnBoardingFormKey,
                  essFormKey,
                  essUserOnBoardingKey
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: w4Data?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'center',
                        alignSelf: 'center'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        Filing Status *
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title="Filing status *"
                        options={options3}
                        selectedOption={mapSelectValue(
                          options3,
                          props.values.maritalstatus
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue('maritalstatus', option - 1)
                        }}
                        textColor="primary"
                      />
                      {props.touched.maritalstatus &&
                        props.errors.maritalstatus && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.maritalstatus}
                          </Text>
                        )}
                    </View>
                  </View>



                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignSelf: 'center',
                        alignItems: 'center',
                        width: '50%'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'If your total income will be $200,000 or less ($400,000 or less if married filing jointly):\n' +
                          'a) Multiply the number of qualifying children under age 17 by $2,200 and enter the amount here *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.ChildTaxCredit_Under17}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('ChildTaxCredit_Under17')(text)
                            props.handleChange('otherdependents')(String(Number(text) + Number(props.values.OtherDependentCredit)))
                          }
                        }}
                      />
                      {props.touched.ChildTaxCredit_Under17 &&
                        props.errors.ChildTaxCredit_Under17 && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.ChildTaxCredit_Under17}
                          </Text>
                        )}
                    </View>
                  </View>

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignSelf: 'center',
                        alignItems: 'center',
                        width: '50%'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'b) Multiply the number of other dependents by $500 and enter the amount here *'}
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.OtherDependentCredit}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('OtherDependentCredit')(text)
                            props.handleChange('otherdependents')(String(Number(text) + Number(props.values.ChildTaxCredit_Under17)))
                          }
                        }}
                      />
                      {props.touched.OtherDependentCredit &&
                        props.errors.OtherDependentCredit && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.OtherDependentCredit}
                          </Text>
                        )}
                    </View>
                  </View>

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignSelf: 'center',
                        alignItems: 'center',
                        width: '50%'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Add the amounts above for qualifying children and other dependents. You may add to this the amount of any other credits. Enter the total here *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight, globalStyles.inputReadOnly,
                        ]}
                        value={props.values.otherdependents}
                        keyboardType="numeric"
                      />
                      {props.touched.otherdependents &&
                        props.errors.otherdependents && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.otherdependents}
                          </Text>
                        )}
                    </View>
                  </View>




                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'center',
                        alignSelf: 'center',
                        width: '50%'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'If you want tax withheld for other income you expect this year that won’t have withholding, enter the amount of other income here. This may include interest, dividends, and retirement income *'}
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.otherIncome}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('otherIncome')(text)
                          }
                        }}
                      />
                      {props.touched.otherIncome &&
                        props.errors.otherIncome && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.otherIncome}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignSelf: 'center',
                        alignItems: 'center',
                        width: '50%'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Use the Deductions Worksheet on page 4 to determine the amount of deductions you may claim, which will reduce your withholding. (If you skip this line, your withholding will be based on the standard deduction.) Enter the result here *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.deductions}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('deductions')(text)
                          }
                        }}
                      />
                      {props.touched.deductions && props.errors.deductions && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.deductions}
                        </Text>
                      )}
                    </View>
                  </View>
                  {Number(props.values.claimExemption) !== 1 && (
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View
                        style={{
                          justifyContent: 'center',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Extra withholding Per Pay'}
                        </Text>
                      </View>
                      <View style={{ width: '30%', overflow: 'hidden' }}>
                        <TextInput
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.extraWithholdingPerPay}
                          keyboardType="numeric"
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('extraWithholdingPerPay')(text)
                            }
                          }}
                        />
                        {props.touched.extraWithholdingPerPay &&
                          props.errors.extraWithholdingPerPay && (
                            <Text style={[globalStyles.dangerAlert]}>
                              {props.errors.extraWithholdingPerPay}
                            </Text>
                          )}
                      </View>
                    </View>
                  )}
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: '60%'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Do you have only two jobs, and does the lower-paying job earn more than half of the higher-paying one? *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title={
                          'Do you have only two jobs, and does the lower-paying job earn more than half of the higher-paying one? *'
                        }
                        options={options2}
                        selectedOption={mapSelectValue(
                          options2,
                          props.values.multiplejobs
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue('multiplejobs', option - 1)
                        }}
                        textColor="primary"
                      />
                      {props.touched.multiplejobs &&
                        props.errors.multiplejobs && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.multiplejobs}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View
                      style={{
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: '60%'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'I claim exemption from withholding for 2026, and I certify that I meet both of the conditions for exemption for 2026. See Exemption from withholding on page 2. I understand I will need to submit a new Form W-4 for 2027 *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title={
                          'I claim exemption from withholding for 2026, and I certify that I meet both of the conditions for exemption for 2026. See Exemption from withholding on page 2. I understand I will need to submit a new Form W-4 for 2027'
                        }
                        options={options2}
                        selectedOption={mapSelectValue(
                          options2,
                          props.values.claimExemption
                        )}
                        onSelect={(option: any) => {
                          const val = option - 1
                          props.setFieldValue('claimExemption', val)
                          if (val === 1) {
                            props.setFieldValue('extraWithholdingPerPay', '')
                          }
                        }}
                        textColor="primary"
                      />
                      {props.touched.claimExemption &&
                        props.errors.claimExemption && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.claimExemption}
                          </Text>
                        )}
                    </View>
                  </View>
                </View>
              </Card>
              {loading ? (
                <ActivityIndicator />
              ) : (
                <View style={{ margin: 10 }}>
                  <CustomButton
                    text={mode === 'upload' ? 'Submit Information' : 'Next'}
                    onPress={props.handleSubmit}
                  />

                </View>
              )}
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}

export default NmInformationForm
